export const VaultType = {
  INDEX: 'INDEX',
  YIELD: 'YIELD',
};
